/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { extract } from '@app/core';
import { SuppliersListComponent } from '@app/suppliers/suppliers/suppliers-list/suppliers-list.component';
import { MenuService } from '@app/core/menu/menu.service';

const routes: Routes = [
  Shell.childRoutes([{ path: 'suppliers', component: SuppliersListComponent, data: { title: extract('Suppliers') } }]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SuppliersRoutingModule {
  constructor(menuService: MenuService) {
    menuService.addItem({
      key: 'suppliers',
      title: 'Suppliers',
      icon: 'fal fa-users',
      requiredPermission: 'suppliers.menu',
      path: '/suppliers',
    });
  }
}
